module.exports = __webpack_public_path__ + "img/epay-zy-dy.22bb155d.png";